module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isRelation) ? _c('Tab', {
    attrs: {
      "title": "收费系统设置",
      "tabList": _vm.tabList,
      "path": _vm.path
    }
  }, [_c('SmartForm', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "slot": _vm.tabName,
      "formList": _vm.tabName === 'manufacturer' ? _vm.manufacturerList : _vm.httpList,
      "formLabelWidth": 120,
      "columns": _vm.columns,
      "relationList": _vm.relationList,
      "values": _vm.tabName === 'manufacturer' ? _vm.formValue.manufacturer : _vm.formValue.setHttp,
      "buttonList": _vm.manuButtonList
    },
    slot: _vm.tabName
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af662ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/ChargeSetting.vue
// module id = 1687
// module chunks = 1